let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cGigZ")).then(() => parcelRequire('hWHpM'));